<template>
  <b-modal v-model="showModal" header-bg-variant="light"
           title="Matching trips for your request"
           scrollable title-class="matching-modal-title"
           size="xl"
           ok-only
           ok-title="Close"
           @cancel="hide"
           @close="hide">
    <div class="row ">
      <div class="col-11" style="margin: 0 auto">
        <ListingComponent class="bg-white"
                          ref="matchingTrips"
                          matchingTrips
                          withDetails hideFooter
                          :requestProvider="requestProvider"
                          :columnConfig="columnConfig">
        </ListingComponent>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
import {
  EST,
  EST_ZONE
} from '@/constants'
import '@/mixins/generalMixin'
export default {
  name: 'MatchingTripsModal',
  data () {
    return {
      request: {},
      showModal: false,
      selectedCompany: null,
      selectedStatus: null,
      showFilterButton: true,
      item: null,
      filterData: {},
      status: '',
      statusMessage: '',
      columnConfig: [
        {
          columnCode: 'origin',
          columnName: 'Start Location',
          custom: true,
          align: 'left',
          value: item => {
            const origin = item.originLocationCode + ' ' + item.originCity + ', ' + item.originState
            const date = this.fullDateTimeFormat(item.pickupTime, item.originTimezone)
            return (
              <div class="row align-items-center">
                <div class="col-md-1 text-right"><span class="stop-number-circle">1</span></div>
                <div class="col-md-10">
                  <div class="line-break">
                    {origin}</div>
                  <small>{date}</small>
                </div>
              </div>
            )
          }
        },
        {
          columnCode: 'destination',
          columnName: 'End Location',
          custom: true,
          align: 'left',
          value: item => {
            const destination = item.destinationLocationCode + ' ' + item.destinationCity + ', ' + item.destinationState
            const date = this.fullDateTimeFormat(item.deliveryTime, item.destinationTimeZone)
            const stopCount = item.stopCount ? item.stopCount : 2
            return (
              <div class="row align-items-center">
                <div class="col-md-1 text-right"><span class="stop-number-circle">{stopCount}</span></div>
                <div class="col-md-10">
                  <div class="line-break">
                    {destination}</div>
                  <small>{date}</small>
                </div>
              </div>
            )
          }
        },
        {
          columnCode: 'distance',
          columnName: 'Distance',
          custom: true,
          align: 'left',
          value: item => {
            const distance = (item.distance).toFixed(2) + 'mi'
            const duration = this.formatDuration(item.duration)
            return (
              <div>
                <div class="line-break">{distance}</div>
                <small>{duration}</small>
              </div>
            )
          }
        },
        {
          columnCode: 'driverType',
          columnName: 'Driver type',
          custom: true,
          value: item => {
            let driverType = ''
            if (item.driverType === 'TEAM_DRIVER') {
              driverType = <i class='fas fa-user-friends'></i>
            } else {
              driverType = <i class='fas fa-user'></i>
            }
            return (
              <div>
                {driverType}
              </div>
            )
          }
        },
        {
          columnCode: 'payout',
          columnName: 'Payout',
          custom: true,
          align: 'left',
          value: item => {
            const price = (item.payout).toFixed(2)
            const pricePerMile = (item.pricePerMile).toFixed(2)
            return (
              <div>
                <div class="line-break">${price}</div>
                <small>${pricePerMile}/mi</small>
              </div>
            )
          }
        },
        {
          columnCode: 'date',
          columnName: 'Date',
          custom: true,
          align: 'left',
          value: item => {
            const dateFormatted = this.dateTimeFormat(item.createdAt, EST_ZONE)
            return (
              <div>
                {dateFormatted} <small>{EST}</small>
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    show (request) {
      this.request = request
      this.showModal = true
    },
    hide () {
      this.request = {}
      this.showModal = false
    },
    requestProvider (payload) {
      return this.axios.post('api/matching-trips', this.request)
    },
    formatDuration (miliseconds) {
      const totalSeconds = parseInt(Math.floor(miliseconds / 1000))
      const totalMinutes = parseInt(Math.floor(totalSeconds / 60))
      const totalHours = parseInt(Math.floor(totalMinutes / 60))
      const days = parseInt(Math.floor(totalHours / 24))

      const minutes = parseInt(totalMinutes % 60)
      const hours = parseInt(totalHours % 24)
      if (days > 0) {
        return days + 'd ' + hours + 'h'
      } else if (hours > 0) {
        return hours + 'h ' + minutes + 'm'
      } else {
        return minutes + 'm'
      }
    }
  },
  computed: {
    hasContent () {
      if (!this.$refs.matchingTrips) {
        return false
      }
      return this.$refs.matchingTrips.hasContent > 0
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>
</style>
